<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('ssl.reissue') }}
                    </span>
                </div>
            </div>
        </div>
        <div class="page-block__item-nav">
            <router-link :to="{ name: '' }">
                <button type="button" class="btn btn--ghost btn--ghost-full-width" @click="openReissueModal">
                    {{ trans('ssl.renew-label') }}
                </button>
            </router-link>
        </div>
        <ssl-reissue-modal v-if="reissueModalvisible" :domain="subscription.domain"></ssl-reissue-modal>
    </div>
</template>

<script>
import SslReissueModal from "./SslReissueModal";
export default {
    name: "SslReissue",
    components: {SslReissueModal},
    props: {
        subscription: {
            type: Object,
            required: true
        }
    },
    mounted(){
        /**
         * Receiving call from child component
         */
        this.$root.$on('closedModal',() => {
           this.closeReissueModal();
        });
    },
    data() {
        return {
            reissueModalvisible: false,
        };
    },
    methods: {
        openReissueModal() {
            this.reissueModalvisible = true;
        },
        closeReissueModal(){
            this.reissueModalvisible = false;
        }
    }
}
</script>
